import { render } from "./StatementOfActivity.vue?vue&type=template&id=f263215a&scoped=true"
import script from "./StatementOfActivity.vue?vue&type=script&lang=js"
export * from "./StatementOfActivity.vue?vue&type=script&lang=js"

import "./StatementOfActivity.vue?vue&type=style&index=0&id=f263215a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f263215a"]])

export default __exports__